/* Upgrade standalone CTA links in product story panel rich text to the
   sitewide arb-button + Button 038 animation. Targets paragraphs whose only
   content is a single <a> (e.g. "EXPLORE THE RANGE" from metafield rich text). */
(function () {
  function upgradeStoryPanelCtaLinks(root) {
    var scope = root || document;
    scope.querySelectorAll('.arb-product-story-panel__body p').forEach(function (paragraph) {
      if (paragraph.dataset.arbStoryCtaReady === 'true') return;

      var link = paragraph.querySelector(':scope > a');
      if (!link || paragraph.children.length !== 1) return;
      if (paragraph.textContent.trim() !== link.textContent.trim()) return;

      paragraph.dataset.arbStoryCtaReady = 'true';
      paragraph.classList.add('arb-product-story-panel__cta');

      if (!link.classList.contains('arb-button')) {
        link.classList.add('arb-button', 'arb-button--primary');
      }
      link.removeAttribute('style');
    });

    if (typeof window.arbInitButton038 === 'function') window.arbInitButton038();
  }

  function init(event) {
    var root = event && event.target && event.target.querySelector
      ? event.target
      : document;
    upgradeStoryPanelCtaLinks(root);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
